import { AfterViewInit, Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-code-type',
  template: `
    <label>{{ props.label }}</label>
    <code-input
      [id]="idElement"
      language="{{ props.codeType ?? 'HTML' }}"
      placeholder="Digite o código aqui"
      template="syntax-highlighted"
      (keyup)="setNewValue($event)">
    </code-input>
    <mat-form-field class="hide-form" appearance="outline">
                <textarea
                  matInput
                  [placeholder]="props.placeholder"
                  [formControl]="formControl" [formlyAttributes]="field"
                ></textarea>
    </mat-form-field>
  `,
  styleUrls: ['./formly-field-code-type.component.scss'],
  standalone: false
})
export class FormlyFieldCodeTypeComponent extends FieldType<FieldTypeConfig> implements AfterViewInit {
  idElement: any;

  constructor() {
    super();
  }

  ngAfterViewInit() {
    this.idElement = this.props.id ? `codeInput${this.props.id}` : 'codeInput';
    this.trySetElementValue(this.idElement, this.formControl?.value, 5, 300);
  }

  private trySetElementValue(id: string, value: any, attempts: number, delay: number) {
    let tryCount = 0;

    const tryFind = () => {
      const codeElement = document.getElementById(id);
      if (codeElement) {
        // @ts-ignore
        codeElement.value = value;
      } else {
        tryCount++;
        if (tryCount < attempts) {
          setTimeout(tryFind, delay);
        } else {
          console.error(`Elemento com id "${id}" não encontrado após ${attempts} tentativas.`);
        }
      }
    };

    // Primeira tentativa imediata
    tryFind();
  }

  setNewValue(value: any) {
    this.formControl.setValue(value?.target?.value);
  }
}
